import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// 引入 Element Plus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

// 如果需要中文国际化，可按需引入
import zhCn from 'element-plus/es/locale/lang/zh-cn'

import createDatetime from 'vue-datetime3'
import { Settings } from 'luxon'
import 'vue-datetime3/style.css'

Settings.defaultLocale = 'zh-cn'
const app = createApp(App)

// 全局注册 Element Plus，并设置语言为中文
app.use(ElementPlus, {
    locale: zhCn
})
app.use(router)
// 注册
app.use(createDatetime());

app.mount('#app')
